import './VideosBlock.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import BlogCard from "../../uiElements/cards/blogCard/BlogCard";
import {BlogBlockArrIcon} from "../../../assets/images";


function VideosBlock(props){
    const {video,staticTexts} = props

    return <div className={'videoBlock-wrapper'}>
        {
            video?.length ? <Link to={'/video'} className={'videoBlock-header'}>
                <div className={'videoBlock-title'}>
                    {staticTexts?.homepage_video_title}
                </div>
                <div className={'videoBlock-more'}>
                    <BlogBlockArrIcon/>
                </div>
            </Link> : ''
        }
        <div className={'videoBlock'}>
            {
                video?.map(item => {
                    return <div className={'videoBlock-cards'}>
                        <BlogCard item={item}/>
                    </div>
                })
            }
        </div>
    </div>
}const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'requestLoading',
        'video',
    ])
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps,mapDispatchToProps)(VideosBlock);